import * as React from 'react'
import { api } from '../lib/api'
import Card from '@mui/joy/Card'
import Input from '@mui/joy/Input'
import Textarea from '@mui/joy/Textarea'
import Button from '@mui/joy/Button'

interface User {
  name: string
  headline: string
  location: string
  bioMd: string
  experienceYears: number
  desiredSalaryMin: number
  desiredSalaryMax: number
  openToRemote: boolean
}

export default function Account() {
  const [u, setU] = React.useState<User | null>(null)
  React.useEffect(() => {
    api('/users/me').then(setU)
  }, [])
  const save = async () => {
    await api('/users/me', { method: 'PUT', body: JSON.stringify(u) })
    alert('Saved')
  }
  if (!u) return <div className="p-6">Loading…</div>
  return (
    <div className="max-w-3xl mx-auto p-6 space-y-4">
      <h2 className="text-2xl font-semibold">My Account</h2>
      <Card className="space-y-3" variant="outlined">
        <Input
          value={u.name || ''}
          onChange={(e) => setU({ ...u, name: e.target.value })}
          placeholder="Full name"
        />
        <Input
          value={u.headline || ''}
          onChange={(e) => setU({ ...u, headline: e.target.value })}
          placeholder="Headline"
        />
        <Input
          value={u.location || ''}
          onChange={(e) => setU({ ...u, location: e.target.value })}
          placeholder="Location"
        />
        <Textarea
          value={u.bioMd || ''}
          onChange={(e) => setU({ ...u, bioMd: e.target.value })}
          placeholder="Bio (markdown)"
        />
        <div className="flex gap-2">
          <Input
            type="number"
            value={u.experienceYears || 0}
            onChange={(e) => setU({ ...u, experienceYears: parseInt(e.target.value || '0') })}
            placeholder="Years experience"
          />
        </div>
        <div className="flex gap-2">
          <Input
            type="number"
            value={u.desiredSalaryMin || ''}
            onChange={(e) => setU({ ...u, desiredSalaryMin: parseInt(e.target.value || '0') })}
            placeholder="Desired min salary"
          />
          <Input
            type="number"
            value={u.desiredSalaryMax || ''}
            onChange={(e) => setU({ ...u, desiredSalaryMax: parseInt(e.target.value || '0') })}
            placeholder="Desired max salary"
          />
        </div>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={u.openToRemote ?? true}
            onChange={(e) => setU({ ...u, openToRemote: e.target.checked })}
          />{' '}
          Open to remote
        </label>
        <div className="text-right">
          <Button onClick={save}>Save</Button>
        </div>
      </Card>
    </div>
  )
}
